export default () => ({
  filters: {},
  links: [],
  pagination: {},
})
